import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { ConditionTable } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class A071Repository extends RepositoryBase<ConditionTable> {
  protected readonly KEY_PATH = 'a071';
}
